/* Fotos del mega menú PAPOS en el drawer del celular.
   snippets/papos-drawer-mega.liquid deja un <template data-papos-drawer-mega="clave"> por bloque papos_mega;
   blocks/_menu-tab-item.liquid deja un hueco [data-papos-mega-slot="clave"] en cada submenú.
   El drawer multi-tab de Ella llega por section-fetcher (después de la carga), por eso se observa el DOM. */
(function () {
  'use strict';

  function fill() {
    var slots = document.querySelectorAll('[data-papos-mega-slot]:not([data-papos-filled])');
    for (var i = 0; i < slots.length; i++) {
      var slot = slots[i];
      var key = slot.getAttribute('data-papos-mega-slot');
      var tpl = document.querySelector('template[data-papos-drawer-mega="' + key + '"]');
      slot.setAttribute('data-papos-filled', '');
      if (!tpl) continue;
      slot.appendChild(tpl.content.cloneNode(true));
      slot.hidden = false;
      if (tpl.getAttribute('data-replace-links') === 'true') {
        var panel = slot.closest('.menu-drawer__inner-submenu');
        if (panel) panel.classList.add('papos-dmega-replace');
      }
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      fill();
    });
  }

  function init() {
    fill();
    var root = document.getElementById('Drawer-Menu') || document.body;
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
